import {
  GraphQLID,
  GraphQLString,
  GraphQLObjectType,
  GraphQLNonNull,
  GraphQLBoolean
} from 'graphql'
import { Organization, organization } from './organization'

export interface User {
  readonly id: string
  readonly firstName: string
  readonly lastName: string
  readonly currentOrganization: Organization
  readonly protect: boolean
  readonly locale: boolean
  readonly datePreference: {
    readonly showPeriod: boolean
  }
}

const datePreferenceType = new GraphQLObjectType({
  name: 'DatePreference',
  fields: () => ({
    showPeriod: {
      description: 'Whether or not to show AM/PM for times',
      type: new GraphQLNonNull(GraphQLBoolean)
    }
  })
})

export const userType = new GraphQLObjectType({
  name: 'User',
  fields: () => ({
    id: {
      description: 'The unique ID for the user',
      type: new GraphQLNonNull(GraphQLID)
    },
    firstName: {
      description: "The user's first name",
      type: new GraphQLNonNull(GraphQLString)
    },
    lastName: {
      description: "The user's last name",
      type: new GraphQLNonNull(GraphQLString)
    },
    currentOrganization: {
      description:
        'The organization either last used or actively in use by the user',
      type: new GraphQLNonNull(organization)
    },
    protect: {
      description: 'Whether or not the user has access to protect features',
      type: new GraphQLNonNull(GraphQLBoolean)
    },
    locale: {
      description: 'Language and location setting',
      type: new GraphQLNonNull(GraphQLString)
    },
    datePreference: {
      description: 'Date Formatting pereferences',
      type: new GraphQLNonNull(datePreferenceType)
    }
  })
})
